import React, { useState } from 'react';
import {TextareaAutosize, FormHelperText, InputLabel } from '@mui/material/';
import {useStyles} from './style';

export default function FormAreaTexto(props) {
    const classes = useStyles(props);
    const [self] = useState(props.this);
    return (
        <>
            {props.showInputTextArea && (
                <div className={classes.formControl}>
                    <InputLabel htmlFor="component-error" className={classes.InputLabel}>{props.label}</InputLabel>
                    <TextareaAutosize
                        className={classes.formControl}
                        key={props.name}
                        id={props.name}
                        name={props.name}
                        maxRows={props.maxRows}
                        minRows={props.minRows}
                        aria-label="maximum height"
                        placeholder={props.label}
                        value={props.value}
                        onChange={(event)=>{ props.handleChange(event,self) }}
                        disabled={props.disabled}
                        autoFocus={props.autofocus}
                    />
                    {(props.isError) ? <FormHelperText className="Mui-error" id="component-error-text">{props.errorMessages}</FormHelperText> : null }
                </div>
            )}
        </>
    )
}

FormAreaTexto.defaultProps = {
    maxRows : 10,
    minRows: 3,
    showInputTextArea: true,
    value: "",
}